import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false

import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.min.css'
//import 'vue-material/dist/theme/default.css'

import vuetify from './plugins/vuetify'


import Vuex from "vuex";
import { store } from './store';
import { router } from './helpers';

import VueProgrammaticInvisibleGoogleRecaptcha from 'vue-programmatic-invisible-google-recaptcha'

import { ValidationProvider, ValidationObserver } from 'vee-validate';

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
Vue.component('vue-programmatic-invisible-google-recaptcha', VueProgrammaticInvisibleGoogleRecaptcha)

Vue.use(VueMaterial)
Vue.use(Vuex);

import * as VueGoogleMaps from "vue2-google-maps";

Vue.use(VueGoogleMaps, {
    load: {
        key: "AIzaSyCamWetJvmMhdb75hzd3uvkB72MZNEtJDU",
        //key: "AIzaSyCidyuXoFfMJfCbVLZF9blr4ZdF3EFDP24", // with searchable
        libraries: "places" // necessary for places input
    }
});

import vueVimeoPlayer from 'vue-vimeo-player'
Vue.use(vueVimeoPlayer)

import VueGtag from "vue-gtag";

Vue.use(VueGtag, {
    config: { id: "UA-32748279-2" },
    enabled: (process.env.NODE_ENV === 'production' && localStorage.getItem('vue-cookie-accept-decline-myPanel1') === 'accept'),
    params: {
        send_page_view: false
    }
}, router);

import 'vue-cookie-accept-decline/dist/vue-cookie-accept-decline.css'
import VueCookieAcceptDecline from 'vue-cookie-accept-decline'
Vue.component('vue-cookie-accept-decline', VueCookieAcceptDecline)

import VueMeta from 'vue-meta'

Vue.use(VueMeta, {
    // optional pluginOptions
    refreshOnceOnNavigation: true
})

import VueClipboard from 'vue-clipboard2'

VueClipboard.config.autoSetContainer = true

Vue.use(VueClipboard)

import LoadScript from 'vue-plugin-load-script';

Vue.use(LoadScript);

import * as Sentry from "@sentry/vue";
import { BrowserTracing } from "@sentry/tracing";

Sentry.init({
    Vue,
    dsn: "https://47267356923848fb8cf7069b7cdbadb8@o153217.ingest.sentry.io/6610579",
    integrations: [
        new BrowserTracing({
            routingInstrumentation: Sentry.vueRouterInstrumentation(router),
            tracingOrigins: ["localhost", "findmykit.com", /^\//],
        }),
    ],
    enabled: process.env.NODE_ENV !== 'development',
    logErrors: true,
    debug: process.env.NODE_ENV === 'development',
    environment: process.env.NODE_ENV,
    release: "helios-vue-frontend@" + process.env.VUE_APP_VERSION,
    beforeSend(event) {
        // Modify the event here
        if (event.exception && event.exception.values) {
            if (event.exception.values[0].value.includes('t._clickOutside is undefined')) {
                return null
            }
            else if (event.exception.values[0].value.includes("undefined is not an object (evaluating 't.$refs.content.contains')")) {
                return null
            }
        }

        return event;
    },
    tracesSampler: samplingContext => {
        // Examine provided context data (including parent decision, if any) along
        // with anything in the global namespace to compute the sample rate or
        // sampling decision for this transaction

        if (samplingContext.transactionContext.op === 'pageload' && samplingContext.transactionContext.name === '/') {
            // These are important - take a big sample
            return 0.5;
        } else {
            // Default sample rate
            return 0;
        }
    }
});

import VueFlags from "@growthbunker/vueflags";

Vue.use(VueFlags, {
    // Specify the path of the folder where the flags are stored.
    iconPath: '/flags/',
});

import { i18n } from "./i18n";

new Vue({
    router,
    vuetify,
    store,
    i18n,
    render: h => h(App),
    mounted: () => document.dispatchEvent(new Event("x-app-rendered")),
}).$mount('#app')
